import "./index.css";

export function PrintContentDetail({ summaryLong }: { summaryLong: string }) {
  return (
    <div id="contentTextBox">
      <span className="page-break">&nbsp;{summaryLong}</span>
    </div>
  );
}
